<template>
  <div>
    <div
      class="mdl-card mdl-shadow--2dp"
      style="margin-bottom: 1em;">

      <div
        class="mdl-card__title unanswered"
        style="background: linear-gradient(to bottom,  rgba(0, 0, 0, 0) 0%, #04afb9 160%), url('../../../../static/assets/emptyprophygroup.jpg') center / cover">
        <h2 class="mdl-card__title-text">
          <span v-if="prophy.recentElapsedMonth < 1">
            {{ prophy.study.header }}<br>
            Trend Report: Baseline
          </span>
          <span v-else>
            {{ prophy.study.header }}<br>
            Trend Report: Month {{ prophy.recentElapsedMonth }}
          </span>
        </h2>
      </div>
      <div
        v-if="showCountdownTimer"
        class="ui top right attached label"
        style="background-color: rgba(38, 61, 75, 0.7); color: white; text-shadow: none;">
        {{ prophy.daysToNextInput }} days to next check-in
      </div>

      <!-- <div
        class="ui top left attached label"
        style="background-color: rgba(38, 61, 75, 0.7); color: white; text-shadow: none;">
        {{ participantsEstimate }} participants
      </div> -->

      <div
        class="mdl-card__supporting-text"
        style="padding-bottom: 0;">
        <p v-if="showCheckInButton">
          You can now add your Month {{ prophy.recentElapsedMonth }} data.
        </p>
      </div>
      <div
        class="mdl-card__actions mdl-card--border"
        style="padding-bottom:0.5em;">
        <p v-if="prophy.endDate !== null">You have stopped taking {{ prophy.molecule }}</p>

        <div
          v-if="showCheckInButton"
          class="ui fluid big button"
          style="background-color: #F38F24; color: white; margin-bottom: 0.5em;"
          @touchend="goToRecentCheckIn">
          Check-In for Month {{ prophy.recentElapsedMonth }} <i class="right chevron icon"/>
        </div>

        <div
          class="ui fluid big tertiary button trend-button"
          @click="viewProphyReports">
          See Results <i class="right chevron icon"/>
        </div>

        <div
          class="ui inverted left labeled icon label trend-label"
          style="background-color:#263d4b">
          <i class="users icon"/>
          <span v-if="prophy.nb_baseline_answers < RECURRING_UNLOCK_LIMIT">
            {{ RECURRING_UNLOCK_LIMIT - prophy.nb_baseline_answers }} more participants required to generate trend comparisons
          </span>
          <span v-else>
            {{ participantsEstimate }} participants in this study
          </span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ProphyStudyCard',
  props: {
    prophy: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['recurringResponseOverall']),

    recurringFormId: function () {
      return this.prophy.study.recurringFormId
    },
    baselineFormId: function () {
      return this.prophy.study.baselineFormId
    },
    RECURRING_UNLOCK_LIMIT: function () {
      return process.env.RECURRING_UNLOCK_LIMIT
    },
    showCheckInButton: function () {
      if (this.prophy.recentElapsedMonth > 0 && this.prophy.lastCompletedMonth !== this.prophy.recentElapsedMonth && this.prophy.endDate === null) {
        return true
      } else {
        return false
      }
    },
    showCountdownTimer: function () {
      if (this.showCheckInButton) {
        return false
      } else if (this.prophy.endDate !== null) {
        return false
      } else {
        return true
      }
    },
    participantsEstimate: function () {
      let number = this.prophy.nb_baseline_answers
      let locale = this.userLang + '-' + this.userCountry

      let output
      if (number < 1000) {
        output = Math.floor(number / 10) * 10
      } else if (number < 10000) {
        output = Math.floor(number / 100) * 100
      } else {
        output = Math.floor(number / 1000) * 1000
      }

      return '~' + output.toLocaleString(locale)
    }
  },
  methods: {
    ...mapActions('prophyStatus', ['updateSelectedProphyReport']),

    goToRecentCheckIn () {
      this.$router.push({ name: 'Questionnaire', params: { formId: this.recurringFormId }, query: { study: this.prophy.study.studyName, country: this.userCountry, lang: this.userLang, uid: this.userId, prophy: this.prophy.molecule, 'recurring_order': this.prophy.recentElapsedMonth > 0 ? this.prophy.recentElapsedMonth : 0, 'start_date': this.prophy.startDate, 'end_date': this.prophy.endDate, 'dosage': this.prophy.dosage }})
    },
    viewProphyReports () {
      amplitude.getInstance().logEvent('QB', { 'Click': 'See Results: ' + this.prophy.study.studyName });

      let month = 0
      if (this.prophy.recentElapsedMonth > 0) {
        month = this.prophy.recentElapsedMonth
      }

      this.$router.push({ name: 'RecurringResults', params: { study: this.prophy.study.studyName, month: month }, query: { country: this.userCountry, lang: this.userLang, uid: this.userId } })
    }
  }
}
</script>

<style scoped>

.trend-button {
  border-radius: .28571429rem .28571429rem 0 0;
}

.trend-label {
  border-radius: 0 0 .28571429rem .28571429rem;
  margin-left: 0;
  width: 100%;
}

.button-container {
  min-height: 3rem;
}

</style>



// WEBPACK FOOTER //
// src/components/survey/recurring/ProphyStudyCard.vue